import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft } from "lucide-react";
import { useSalesAuth } from "@/lib/auth";
import { extractErr } from "@/lib/api";
import { PLATFORM_LOGO_URL } from "@/lib/brand";
import Brand from "@/components/Brand";
import LoginPasswordInput, { passwordFromForm } from "@/components/LoginPasswordInput";

export default function SalesLogin() {
  const nav = useNavigate();
  const { login } = useSalesAuth();
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const password = passwordFromForm(e.currentTarget);
    setLoading(true);
    try {
      await login(username, password);
      toast.success("Welcome to Sales Panel");
      nav("/sales");
    } catch (err) { toast.error(extractErr(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#090D16] text-slate-100 flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 text-sm text-slate-500 hover:text-white mb-8" data-testid="sales-back"><ArrowLeft className="w-4 h-4" /> Home</Link>
        <div className="mb-6" data-testid="sales-login-logo">
          <Brand variant="dark" size="md" src={PLATFORM_LOGO_URL} />
        </div>
        <h1 className="font-display text-2xl font-bold">Sales sign in</h1>
        <p className="text-slate-500 text-sm mt-1">Manage clients, addons, support, coupons, and leads.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div><Label className="text-slate-300">Username</Label><Input data-testid="sales-username" className="bg-slate-900 border-slate-800 text-white mt-1" value={username} onChange={(e) => setUsername(e.target.value)} required autoComplete="username" /></div>
          <div><Label className="text-slate-300">Password</Label><LoginPasswordInput testId="sales-password" className="bg-slate-900 border-slate-800 text-white mt-1" /></div>
          <Button type="submit" disabled={loading} data-testid="sales-submit" className="w-full h-11 bg-teal-500 hover:bg-teal-600 text-slate-950 font-semibold rounded-full">{loading ? "Signing in…" : "Sign in"}</Button>
        </form>
      </div>
    </div>
  );
}
